module.exports = __webpack_public_path__ + "static/media/AC.ff7868ac.svg";